import React, { createContext, useContext, useEffect, useState } from 'react';
// import io from 'socket.io-client'; // Disabled to stop WebSocket traffic

// Create a WebSocket context
const WebSocketContext = createContext(null);

// WebSocket provider component
export const WebSocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Provide a dummy socket to prevent errors but stop actual traffic
    const dummySocket = {
      id: 'disabled-socket',
      on: () => {},
      off: () => {},
      emit: () => {},
      close: () => {},
      disconnect: () => {}
    };

    setSocket(dummySocket);

    // Clean up on unmount
    return () => {
      // dummySocket.close();
    };
  }, []);

  // Provide the socket and any additional functionality
  const value = {
    socket,
    // You can add more functions here that use the socket
  };

  return (
    <WebSocketContext.Provider value={value}>
      {children}
    </WebSocketContext.Provider>
  );
};

// Custom hook to use the WebSocket context
export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (context === null) {
    throw new Error('useWebSocket must be used within a WebSocketProvider');
  }
  return context;
};